<template>
  <div>
    <b-card v-if="shops.length == 0">
      <div
        class="custom-card-title my-1 pb-1 text-left d-flex justify-content-between"
      >
        <b-skeleton width="30%" height="20%"></b-skeleton>
        <b-skeleton width="20%" height="20%"></b-skeleton>
      </div>
      <b-row class="mt-3">
        <b-col cols="4" md="2" v-for="item in 6" :key="item">
          <b-card no-body class="text-center border-0 custom-shop-item">
            <b-skeleton-img class="rounded-lg image contain"></b-skeleton-img>
            <b-card-body class="mt-3 d-flex justify-content-center">
              <b-skeleton
                width="40%"
                height="10%"
                class="align-center"
              ></b-skeleton>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    <b-card
      v-else
      no-body
      class="custom-card border-0 shadow-sm py-2 pb-3 px-4 flex-grow-1 h-100"
    >
      <div
        class="custom-card-title my-1 pb-1 text-left d-flex justify-content-between"
      >
        <p class="font-weight-bolder">
          <b-icon-shop class="text-primary"></b-icon-shop>&nbsp;
          {{ $t('home_recommendedShopLabel') }}
        </p>
        <b-button-group>
          <b-button
            variant="outline-primary"
            size="sm"
            class="mr-2"
            small
            @click="scrollToLeft"
            ><b-icon-chevron-left></b-icon-chevron-left
          ></b-button>
          <b-button variant="outline-primary" size="sm" @click="scrollToRight">
            <b-icon-chevron-right></b-icon-chevron-right
          ></b-button>
        </b-button-group>
        <!-- <router-link to="/shops" class="text-primary">
          All Shops <b-icon-chevron-right></b-icon-chevron-right>
        </router-link> -->
      </div>

      <b-row class="cards">
        <div v-for="(shop, index) in shops" :key="`recommendshop-${index}`">
          <router-link
            v-if="shop != 'redirectItem'"
            :to="{ name: 'ShopHome', params: { id: shop.slug || shop.id } }"
            class="text-decoration-none"
          >
            <b-card no-body class="border-0 custom-shop-item">
              <b-card-img-lazy
                :src="shop.companyLogoUrl || placeholder"
                :blank-src="placeholder"
                :alt="shop.name"
                style="width: 200px; height: 200px"
                class="rounded-lg shop-card-logo mx-auto"
              ></b-card-img-lazy>

              <p
                class="mb-0 mt-3 text-muted "
                :title="shop.companyName"
              >
                {{ shop.companyName }}
              </p>
            </b-card>
          </router-link>
          <div
            v-else
            class="d-flex justify-content-center align-items-center"
            style="min-height: 300px"
          >
            <div>
              <b-button
                to="/recommendshop"
                size="lg"
                style="border-radius: 100%"
              >
                <b-icon-chevron-right class="my-2"></b-icon-chevron-right>
              </b-button>
              <div class="mt-2">Explore All Recommend Shops</div>
            </div>
          </div>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardImgLazy,
  BIconChevronRight,
  BIconChevronLeft,
  BSkeleton,
  BSkeletonImg,
  BCardBody,
  BIconShop,
  BButton,
  BButtonGroup,
} from 'bootstrap-vue';
import shopService from '../../services/shop.service';

export default {
  components: {
    BCard,
    BCardImgLazy,
    BIconChevronRight,
    BIconChevronLeft,
    BSkeleton,
    BSkeletonImg,
    BCardBody,
    BIconShop,
    BButton,
    BButtonGroup,
  },
  data: () => ({
    placeholder: require('../../assets/images/yoma-placeholder.png'),
    shops: [],
  }),
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  mounted() {
    this.getRecommendedShops();
  },
  methods: {
    async getRecommendedShops() {
      try {
        const res = await shopService.getRecommendedShops({});
        this.shops = res.data.registerList;
        this.shops.push('redirectItem');
      } catch (error) {
        console.error(error);
      }
    },

    scrollToLeft() {
      const cardsContainer = this.$el.querySelector('.cards');
      const currentPosition = cardsContainer.scrollLeft;
      const newPosition = currentPosition - 300; // Adjust scroll distance as needed
      this.scrollTo(cardsContainer, currentPosition, newPosition);
    },
    scrollToRight() {
      const cardsContainer = this.$el.querySelector('.cards');
      const currentPosition = cardsContainer.scrollLeft;
      const newPosition = currentPosition + 300; // Adjust scroll distance as needed
      this.scrollTo(cardsContainer, currentPosition, newPosition);
    },
    scrollTo(element, from, to, duration = 300) {
      const start = performance.now();
      const animateScroll = (timestamp) => {
        const elapsed = timestamp - start;
        const progress = Math.min(elapsed / duration, 1);
        element.scrollLeft = from + (to - from) * progress;
        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      };
      requestAnimationFrame(animateScroll);
    },
  },
};
</script>

<style>
.cards {
  display: grid;
  grid-auto-columns: 100%;
  grid-column-gap: 0px;
  grid-auto-flow: column;
  list-style: none;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  transition: all 0.5s;
}

.cards::-webkit-scrollbar {
  height: 12px;
}

@media (min-width: 500px) {
  .cards {
    grid-auto-columns: calc(50% - 10px);
    grid-column-gap: 10px;
  }
}

@media (min-width: 700px) {
  .cards {
    grid-auto-columns: calc(calc(100% / 3) - 20px);
    grid-column-gap: 10px;
  }
}

@media (min-width: 1100px) {
  .cards {
    grid-auto-columns: calc(20% - 30px);
    grid-column-gap: 10px;
  }
}
</style>
